import http from "./httpService";
const apiEndpoint = "/tpauth";

export function checkToken(projectId, code, location, accountsServer, type) {
  return http.post(apiEndpoint + "/whitelabelThirdpartyauth" + "/" + projectId, {
    code,
    location,
    accountsServer,
    type,
  });
}

export function thirdpartyUpdate(settings, projectId) {
  return http.put(`${apiEndpoint}/whitelabelUpdateThirdPartyData/${projectId}`, settings);
}

export function getthirdpartyData(projectId) {
  return http.get(`${apiEndpoint}/whitelabelGetThirdPartyData/${projectId}`);
}


